/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as _ from 'lodash';

/**.
 * Abstract class for ag context.
 *
 * @template T - modal data;
 */
@Injectable()
export class FcAgContextComponent {
    
    private observer: Observer<any>;
    
    private closerCallback: () => void = () => {};
    
    /**
     * Default constructor.
     */
    constructor() {}
    
    /**
     * Map data to dialog data.
     * 
     * @param data User data.
     */
    mapDataObject(data: any): void {
        _.merge(this, data);
    }
    
    /**
     * Create a observable object.
     * 
     * @returns Observable Observable object.
     */
    setupObserver(): Observable<any> {
        return new Observable((observer: Observer<any>) => {
            this.observer = observer;
        });
    }

    /**
     * Defines what happens when close is called - default this
     * will just call the default remove modal process. If overridden
     * must include.
     *
     * @param callback On closing callback.
     */
    onClosing(callback: () => void): void {
        this.closerCallback = callback;
    }

    /**
     * Close function.
     */
    close(): void {
        this.closerCallback();
        if (this.observer) {
            this.observer.next({});
            this.observer.complete();
        }
    }
}